import React from "react";
import HomePage from "./HomePage";
import GroupPage from "./GroupPage";
import EssayPage from "./EssayPage";
import { Route, Link, HashRouter as Router } from "react-router-dom";
import "./style/main.scss"
import { API } from "../BlakeData";
import Div100vh from 'react-div-100vh';

import Background from './banner-bg.jpg';
import { ReactComponent as YaleLogo } from "./Yale-logo.svg";
import { ReactComponent as BlakeLogo } from "./BlakeTint-Title.svg";

interface Dimensions { width: number, height: number };
/**
 * Main App class for the Blake color app
 */
export default class BlakeApp extends React.Component<{}, {}>{


    state: {
        bd?: boolean,
        dimensions: Dimensions
    }

    constructor(props: object) {
        super(props);
        this.state = {
            dimensions: {
                width: 0,
                height: 0
            }
        };

        API.connect().then((success: boolean) => {
            if (success) {
                // this.setState({ bd });
                this.setState({ bd: true });
            } else {
                console.log("Error loading blake data!");
            }
        })
            .catch((reason: any) => {
                console.error("Error connecting to database: ", reason)
            });

    }


    render() {

        // don't render until there is a BlakeData object
        // so all page views can assume a valid API connection
        if (!this.state.bd) {
            return (null)
        }

        const props = { dimensions: this.state.dimensions }

        return (
            <Div100vh>
                <div className="BlakeApp">
                    <Router>
                        <header style={{ backgroundImage: `url(${Background})` }}>
                            <Link to="/"><div className="BlakeLogo"><BlakeLogo /></div>
                                <div>Quantizing Color in William Blake's Illuminated Books</div>
                            </Link>
                            <span className="subtitle"></span>
                        </header>

                        <React.Fragment>
                            <Route exact path="/group/:mode/:groupID" component={GroupPage} />
                            <Route exact path="/group/:mode/:groupID/:firstImage" component={GroupPage} />
                            <Route exact path="/group/:mode/:groupID/:firstImage/:secondImage" component={GroupPage} />
                            <Route exact path="/essays" component={EssayPage} />
                            <Route exact path="/essays/:slug" component={EssayPage} />


                            {/* <Route exact path="/" component={HomePage} /> */}
                            <Route exact path="/" render={() => <HomePage {...props} />} />
                        </React.Fragment>

                        <footer>
                            <div className="footer-item yale-logo">
                                <YaleLogo height="19px" />
                            </div>
                            <div className="footer-item">
                                <Link to="/essays/about">About</Link>
                            </div>
                            <div className="footer-item">
                                <a href="https://dhlab.yale.edu">Yale DHLab</a>
                            </div>
                        </footer>
                    </Router>
                </div>
            </Div100vh >
        );
    }
}